








import { Component, Vue } from 'vue-property-decorator';
import Cookies from 'js-cookie'
import * as api from '../api'
import globalState from '../globalState'
import App from '../App'

@Component
export default class Login extends Vue {
  username: string = ''
  password: string = ''
  async login() {
    if (this.username || this.password) {
      try {
        let result = await api.invoke('runtime/login', this.username, this.password)
        if (result) {
          Cookies.set('x_sys_auth', result.token)
          globalState.auth = result.token
          this.$router.replace(this.$route.query.returnUrl || '/', () => {
            (this.$root.$children[0] as App).init()
          })
        }
        else {
          alert('请输入用户名或密码错误')
        }
      } catch (error) {
        alert(error)
      }
    }
    else {
      alert('请输入用户名和密码')
    }
  }
}
